import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils";

export const userWiseUnitList = createAsyncThunk('userWiseUnit/list', async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `user_wise_unit`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const userWiseUnit = createSlice({
    name: 'userWiseUnit',
    initialState: {
        list: [],
        loading: false,
    },
    reducers: {
        removeUserWiseUnit: (state, action) => {
            state.list = [];
        },
    },
    extraReducers: (builder) => {
        builder.addCase(userWiseUnitList.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(userWiseUnitList.fulfilled, (state, action) => {
            state.loading = false;
            if (action?.payload?.status === 200) {
                state.list = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.list = []
            }
        });
        builder.addCase(userWiseUnitList.rejected, (state) => {
            state.loading = false;
        });
    }
})

export const { removeUserWiseUnit } = userWiseUnit.actions;
export default userWiseUnit.reducer;